import { nanoid } from 'nanoid';

import { getElementDeserializer } from '../../../../slatePlugins/common/utils/getElementDeserializer';
import { DeserializeHtml } from '../../../../slatePlugins/slatePlugins.types';
import { BLANK_V2 } from './types';

export const deserializeBlankV2 = (): DeserializeHtml => {
  const elmDeserialized = getElementDeserializer({
    type: BLANK_V2,
    attributes: ['data-parent-node-type'],
    node: (el) => {
      return {
        id: nanoid(),
        type: BLANK_V2,
        parentNodeType: el.dataset.parentNodeType,
      };
    },
    rules: [{ className: 'blank-v2' }],
  });

  return {
    element: elmDeserialized,
  };
};
